var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.1582C0 10.8314 2.98771 13.8164 6.65684 13.8164C8.34726 13.8164 9.89353 13.1807 11.0696 12.1387L15.312 16.382C15.3907 16.4607 15.4922 16.5 15.5971 16.5C15.7019 16.5 15.8034 16.4607 15.8821 16.382C16.0393 16.2248 16.0393 15.9725 15.8821 15.8152L11.6364 11.5719C12.6781 10.3956 13.3137 8.85224 13.3137 7.1582C13.3137 3.48505 10.326 0.5 6.65684 0.5C2.98771 0.5 0 3.48505 0 7.1582ZM12.5111 7.1582C12.5111 10.3857 9.8837 13.0136 6.65684 13.0136C3.42998 13.0136 0.802621 10.3857 0.802621 7.1582C0.802621 3.93068 3.42998 1.30279 6.65684 1.30279C9.8837 1.30279 12.5111 3.9274 12.5111 7.1582Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLogo);
export default __webpack_public_path__ + "static/media/search_logo.745fb41a874bd405bb6c92ec11fd13aa.svg";
export { ForwardRef as ReactComponent };